export default __webpack_public_path__ + "static/bg-page-conference-a3a6e2d149883260bb6542a4274f5e2f.jpg";